'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// An icon of Box the file sharing company, not a box with lowercase b.
var Box = (_temp = _class = function (_SvgIcon) {
  _inherits(Box, _SvgIcon);

  function Box() {
    _classCallCheck(this, Box);

    return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
  }

  _createClass(Box, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: '#0075C9',
            d: 'M213.4,159.6c-22.6,0-42.3,12.7-52.2,31.4c-9.9-18.7-29.6-31.4-52.2-31.4c-13.3,0-25.6,4.4-35.5,11.8v-49.8h0 C73.3,115.2,68,110,61.6,110s-11.7,5.2-11.8,11.6h0v98.1h0c0.5,32.2,26.8,58.2,59.1,58.2c22.6,0,42.3-12.7,52.2-31.4 c9.9,18.7,29.6,31.4,52.2,31.4c32.7,0,59.1-26.5,59.1-59.1S246,159.6,213.4,159.6z M108.9,254.2c-19.6,0-35.5-15.9-35.5-35.5 s15.9-35.5,35.5-35.5c19.6,0,35.5,15.9,35.5,35.5S128.5,254.2,108.9,254.2z M213.4,254.2c-19.6,0-35.5-15.9-35.5-35.5 s15.9-35.5,35.5-35.5s35.5,15.9,35.5,35.5S232.9,254.2,213.4,254.2z'
          }),
          _react2['default'].createElement('path', {
            fill: '#0075C9',
            d: 'M352,259.2l-30.3-40.5l30.3-40.5l0,0c3.7-5.2,2.7-12.5-2.5-16.4c-5.2-3.9-12.4-2.9-16.4,2.2l0,0L307,199 l-26.1-34.9l0,0c-4-5.1-11.3-6-16.4-2.2c-5.2,3.9-6.2,11.2-2.5,16.4l0,0l30.3,40.5l-30.3,40.5l0,0c-3.7,5.2-2.7,12.5,2.5,16.4 c5.2,3.9,12.4,2.9,16.4-2.2l0,0l26.1-34.9l26.1,34.9l0,0c4,5.1,11.3,6,16.4,2.2C354.7,271.7,355.8,264.5,352,259.2L352,259.2z'
          })
        );
      }

      return render;
    }()
  }]);

  return Box;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = Box;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Box.js
// module id = 1354
// module chunks = 32